module.exports = ".mat-icon.help {\n  font-size: 13px;\n  cursor: pointer;\n  color: #0d777d; }\n"